const valuetoStatePostalCodeFormatter = (value: string) => {
  if (!value) {
    return '';
  }

  const cleanedValue = String(value).replace(/[^0-9a-z]/gi, '');
  const isValid = cleanedValue.length === 6;

  if (isValid) {
    return cleanedValue;
  }

  return value;
};

export default valuetoStatePostalCodeFormatter;
